import { render, staticRenderFns } from "./service_tickets.vue?vue&type=template&id=72a3c46e&scoped=true&"
import script from "./service_tickets.vue?vue&type=script&lang=js&"
export * from "./service_tickets.vue?vue&type=script&lang=js&"
import style0 from "./service_tickets.vue?vue&type=style&index=0&id=72a3c46e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3c46e",
  null
  
)

export default component.exports